"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "RequiredOnboardingSubtext__CrossedOutPrice",
  componentId: "fwykg2-0"
})(["text-decoration:line-through;"]);

var BringAttention = _styledComponents.default.b.withConfig({
  displayName: "RequiredOnboardingSubtext__BringAttention",
  componentId: "fwykg2-1"
})([""]);

var RequiredOnboardingSubtext = function RequiredOnboardingSubtext(_ref) {
  var billingNameKey = _ref.billingNameKey,
      pricingInfo = _ref.pricingInfo,
      currencyCode = _ref.currencyCode,
      showDiscountedPriceNov1 = _ref.showDiscountedPriceNov1;

  // Show alternate discounted onboarding copy for Sales/Service Pro onboarding
  // Discounted onboarding was hacked together on 11/1 and is temporary. Once given the OK, we can delete this block
  if (showDiscountedPriceNov1) {
    return _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.calculator.requiredOnboardingSubtext." + billingNameKey + "WithDiscount_jsx",
      options: {
        currencyCode: currencyCode,
        fullPrice: pricingInfo.oneTimeFee.fullPrice,
        discountedPrice: pricingInfo.oneTimeFee.calculatedPrice
      },
      elements: {
        PriceDisplay: _PriceDisplay.default,
        CrossedOutPrice: CrossedOutPrice,
        UILink: _UILink.default,
        b: BringAttention
      }
    }));
  }

  return _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.calculator.requiredOnboardingSubtext." + billingNameKey + "_jsx",
    options: {
      currencyCode: currencyCode,
      price: pricingInfo.oneTimeFee.calculatedPrice
    },
    elements: {
      PriceDisplay: _PriceDisplay.default,
      UILink: _UILink.default,
      b: BringAttention
    }
  }));
};

var _default = RequiredOnboardingSubtext;
exports.default = _default;
module.exports = exports.default;